import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-success-modal",
  templateUrl: "./success-modal.component.html",
  styleUrls: ["./success-modal.component.scss"],
  standalone: false,
})
export class SuccessModalComponent implements OnInit {
  @Input() type: string = "";
  @Input() message: string = "";
  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();
  constructor(private modalController: ModalController) {}

  ngOnInit() {}

  click() {
    this.onClick.emit();
  }
}
